<template>
  <div class="box">
    <div class="topImg">
      <el-carousel
        indicator-position="none"
        height="600px"
        arrow="never"
        ref="carousel"
      >
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <div style="positions: relative">
            <img :src="item.coverUrl" alt="" class="itemImg" srcset="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="clickIt">
        <div
          :class="{ cliItem: true, actClick: item.check == true }"
          v-for="(item, index) in imgList"
          :key="index"
          @click="changeCar(index)"
        ></div>
      </div>
    </div>
    <div class="comTop" id="com-1" ref="com-1">
      <div class="title">公司概述</div>
      <div class="flexbox">
        <div
          v-for="(item, index) in colList"
          :key="index"
          :class="{ compIt: true, acttve: item.check }"
          @click="change(index)"
          @mouseover="mouseover(index)"
          @mouseout="mouseout(index)"
        >
          <div class="comName">{{ item.name }}</div>
          <img :src="item.url" class="comImg" alt="" />
          <div
            :class="{ comCont: true, accfont: item.check == true }"
            v-html="item.cont"
          ></div>
        </div>
      </div>
    </div>
    <div class="ydsave">
      <img
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/ydsave.png"
        class="ydImg"
        alt=""
      />
    </div>
    <div class="ywsave" id="com-2">
      <div class="ywTitle">业务板块</div>
      <div class="ywTit">基础服务</div>
      <img
        src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/yw-1.png"
        class="ywImg"
        alt=""
      />
    </div>
    <!-- <div class="ysfw">
      <div class="ysTitle">衍生服务</div>
      <div class="ysbox">
        <div class="ysIt" style="margin-right: 33px">
          <div class="ysTit">谱外人口资料录入</div>
          <img
            src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/ys-1.png"
            class="ysImg"
            alt=""
            srcset=""
          />
        </div>
        <div class="ysIt">
          <div class="ysTit">电子族谱</div>
          <img
            src="https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/ys-2.png"
            class="ysImg"
            alt=""
            srcset=""
          />
        </div>
      </div>
    </div> -->
    <div class="ysfw" style="padding-bottom: 67px">
      <div class="ysTitle">增值服务</div>
      <div class="zzbox">
        <div class="zzIt" v-for="(item, index) in zzList" :key="index">
          <div class="zzTit">{{ item.title }}</div>
          <img :src="item.url" class="zzImg" alt="" srcset="" />
        </div>
      </div>
    </div>
    <div class="sm" id="com-3">
      <div class="smTitle">使命 愿景 价值观</div>
      <div class="smbox">
        <div class="smIt" v-for="(item, index) in smList" :key="index">
          <img :src="item.url" class="smImg" alt="" srcset="" />
          <div class="smTit">{{ item.title }}</div>
          <div class="smCont">{{ item.cont }}</div>
        </div>
      </div>
    </div>

    <!--新闻资讯-->
    <div class="ysfw" style="padding-bottom: 67px">
        <div class="ysTitle">新闻资讯</div>
        <div class="news">
          <!-- <div class="news-tabs">
            <div class="tab-item" v-for="(item, index) in tabsList" :class="thirdType===item.value ? 'active':''" @click="handleClick(item.value)" :key="index">{{item.label}}</div>
          </div>
   -->
          <div class="news-content">
            <div class="content-left">
              <div class="title-top">
                <div>公司动态</div>
                <div class="more-box" @click.stop="goPageNews()" > 查看更多    <img :src="require('@/assets/more-black.png')" class="more-icon" alt="" srcset="" /></div>
              </div>
             
              <div class="news-item"  @click="goMain(item)" v-for="(item, index) in newsLeftList" :key="index" >
                <div class="news-left">{{item.title}}</div>
                <div class="news-right">{{item.createTime}}</div>
              </div>
            </div>
            <div class="content-right" v-show="newsRightList.length>0">
              <div class="title-top">
                <div>行业资讯</div>
                <div class=" more-box" @click.stop="goPageNews()" > 查看更多    <img :src="require('@/assets/more-black.png')" class="more-icon" alt="" srcset="" /></div>
              </div>
             
              <div class="news-item"  @click="goMain(item)" v-for="(item, index) in newsRightList" :key="index" >
                <div class="news-left">{{item.title}}</div>
                <div class="news-right">{{item.createTime}}</div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { getNewsDate } from "@/api/request";
export default {
  components: {},
  data() {
    return {
      imgList: [],
      colList: [
        {
          check: false,
          name: "公司简介",
          cont: "深圳市龙胤网络科技有限公司成立于 2022 年，注册资本 1.2 亿，旗下有知孝传媒、家和文化等多家子公司。<br>我们是一家专注于优良传统文化的互联网科技企业，依托科技手段提供一站式家族服务，实现基业长青。</br>创始团队均来自国内一流的专业人士，秉承“诚信、尊重、创新、合作”的核心价值观，让家族链接更美好。",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/com-1.png",
        },
        {
          check: false,
          name: "公司文化",
          cont: "公司有着独特的文化氛围和价值观念，也是公司的精神支柱和行为准则。公司文化以:创新、 开放、自由、分享为核心价值观，核心价值观包括:客户第一、拥抱变化、团队合作、诚信正直和敬业奉献。<br> 此外，公司的企业文化还强调员工的创造力和创新能力，鼓励员工提出新想法和新方案;注重员工的培训和发展，提供广阔的发展空间和机会;强调员工的福利待遇和工作环境。</br>",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/com-2.png",
        },
        {
          check: false,
          name: "公司团队",
          cont: "公司拥有一支技术实力雄厚、充满活力的团队，这支团队由一群具有丰富经验的专业人才组成。他们在各自的领域具有深厚的技术功底和广泛的知识面，能够迅速响应客户需求，提供高效、专业的解决方案。<br>技术团队成员来自不同背景，包括计算机科学、软件工程、电子工程、通信工程等专业。他们具备扎实的理论基础和丰富的实践经验，能够在项目开发过程中发挥关键作用。</br>",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/com-3.png",
        },
      ],
      zzList: [
        {
          title: "家族纪录片制作",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-1.png",
        },
        {
          title: "数字化云族谱",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-2.png",
        },
        {
          title: "代写谱序人物传记",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-3.png",
        },
        {
          title: "谱外人口资料录入",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-4.png",
        },
        {
          title: "族谱修订印刷",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-5.png",
        },
        {
          title: "宗族活动策划",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-6.png",
        },
        {
          title: "家族文化遗产非遗申报",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-7.png",
        },
        {
          title: "祠堂牌坊等规划建设",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-9.png",
        },
        {
          title: "家族文创产品设计",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-8.png",
        },
        {
          title: "祠堂VR设计制作",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/zz-10.png",
        },
      ],
      smList: [
        {
          title: "公司使命",
          cont: "科技让家族链接更美好",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/sm-1.png",
        },
        {
          title: "公司愿景",
          cont: "打造一站式家族传承综合服务平台",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/sm-2.png",
        },
        {
          title: "公司价值观",
          cont: "诚信、尊重、创新、合作",
          url: "https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/sm-3.png",
        },
      ],
      tabsList:[
        {label:"公司动态",value:101},
        {label:"行业资讯",value:102}
      ],
      thirdType: 101,
      newsLeftList:[],
      newsRightList:[],
    };
  },
  created() {
    this.getLogo();
    this.getNews()
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.carousel._data.activeIndex;
      },
      (val) => {
        //this.$refs.carousel.setActiveItem(val);
        if (this.imgList[val].check == true) {
          this.imgList[val].check = false;
        } else {
          this.imgList[val].check = true;
        }
        this.imgList.map((a, j) => {
          if (val != j) {
            this.imgList[j].check = false;
          } else {
            this.imgList[j].check = true;
          }
        });
        this.$forceUpdate();
      }
    );
  },
  methods: {
    goMain(e) {
      this.$router.push({
        path: "/newsMain",
        query: {
          id: e.id,
        },
      });
    },
    goPageNews(e) {
      this.$router.push({
        path: "/news",
        query: {
          source:'main',
        },
      });
    },
    handleClick(value){
      this.thirdType = value;
      this.getNews()
    },
    getNews() {
      let data = {
        pageNo: 1,
        pageSize: 10,
        type: 1,
        secondType:1,
        thirdType:101,
      };
      getNewsDate(data).then((res) => {
        this.newsLeftList = res.data.result.records;
      });
      let data1 = {
        pageNo: 1,
        pageSize: 10,
        type: 1,
        secondType:1,
        thirdType:102,
      };
      getNewsDate(data1).then((res) => {
        this.newsRightList  = res.data.result.records;
        
      });
    },
    getLogo() {
      let data = {
        pageNo: 1,
        pageSize: 10,
        type: 3,
        secondType: 8,
      };
      getNewsDate(data).then((res) => {
        console.log(res);
        this.imgList = res.data.result.records;
        this.imgList.map((e) => {
          e.check = false;
        });
        this.imgList[0].check = true;
      });
    },
    changeCar(i) {
      this.$refs.carousel.setActiveItem(i);
      if (this.imgList[i].check == true) {
        this.imgList[i].check = false;
      } else {
        this.imgList[i].check = true;
      }
      this.imgList.map((a, j) => {
        if (i != j) {
          this.imgList[j].check = false;
        } else {
          this.imgList[j].check = true;
        }
      });
      this.$forceUpdate();
    },
    change(i) {
      if (this.colList[i].check == true) {
        this.colList[i].check = false;
      } else {
        this.colList[i].check = true;
      }
      this.colList.map((a, j) => {
        if (i != j) {
          this.colList[j].check = false;
        } else {
          this.colList[j].check = true;
        }
      });
      this.$forceUpdate();
    },
    mouseover(i) {
      this.colList[i].check = true;
      this.$forceUpdate();
    },
    mouseout(i) {
      this.colList[i].check = false;
      this.$forceUpdate();
    },
  },
};
</script>
<style  scoped>
.box {
}
.topImg {
  height: 600px;
  position: relative;
}

.itemImg {
  width: 100%;
  height: 600px;
  cursor: pointer;
}

.clickIt {
  display: flex;
  position: absolute;
  bottom: 20px;
  z-index: 10;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.cliItem {
  width: 32px;
  height: 8px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.6);
  margin: 0 6px;
  cursor: pointer;
}

.actClick {
  background: rgba(255, 255, 255, 1);
}
.comTop {
  padding: 100px 260px;
  background: rgba(246, 249, 255, 1);
}
.title {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 50px;
}
.compIt {
  width: 445px;
  height: 652px;
  box-shadow: 0px 0px 8px 0px rgba(227, 231, 235, 1);
  background: #fff;
  cursor: pointer;
  margin: 0 16px;
  padding: 44px 32px;
  box-sizing: border-box;
}
.comImg {
  width: 381px;
  height: 188px;
  margin: 30px 0;
}
.flexbox > :first-child {
  margin-left: 0;
}
.flexbox > :last-child {
  margin-right: 0;
}
.comName {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
}
.comCont {
  text-align: left;
  font-size: 16px;
  line-height: 1.8;
  letter-spacing: 1px;
  color: #999da6;
}
.accfont {
  color: #fff;
}
.acttve {
  background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/img/com-zz.png")
    no-repeat;
  color: #fff;
  background-size: 100% 100%;
}
.flexbox {
  display: flex;
  justify-content: center;
}
.ydsave {
  height: 510px;
}
.ydImg {
  width: 100%;
  height: 100%;
}
.ywsave {
  background: #fff;
  height: 1053px;
}
.ywImg {
  width: 1408px;
  height: 870px;
}
.ywTitle {
  font-size: 32px;
  font-weight: 700;
  margin-top: 100px;
  margin-bottom: 9px;
}
.ywTit {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 57px;
  color: #666;
}
img {
  width: 100%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
.ysfw {
  background: #f6f9ff;
}
.ysTitle {
  font-size: 32px;
  font-weight: 700;
  padding-top: 100px;
  padding-bottom: 50px;
}
.ysbox {
  display: flex;
  justify-content: center;
}
.ysIt {
  width: 684px;
  height: 347px;
  background: #fff;
}
.ysTit {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 44px;
}
.ysImg {
  width: 499px;
  height: 210px;
  cursor: pointer;
  margin-top: 32px;
}
.ysImg:hover {
  width: 575px;
  height: 242px;
  margin-top: 16px;
}
.zzbox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 260px;
  justify-content: space-between;
}
.zzIt {
  width: 253px;
  height: 270px;
  background: #fff;
  margin-bottom: 33px;
}
.zzTit {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 34px;
}
.zzImg {
  width: 184px;
  height: 163px;
  cursor: pointer;
  margin-top: 15px;
}
.smTitle {
  font-size: 32px;
  font-weight: 700;
  padding-top: 100px;
  padding-bottom: 50px;
}
.smbox {
  display: flex;
  flex-wrap: wrap;
  padding: 0 260px;
  justify-content: space-between;
}
.smIt {
  background: #fff;
  padding-bottom: 33px;
}
.smTit {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 16px;
}
.smImg {
  width: 364px;
  height: 243px;
  cursor: pointer;
}
.smCont {
  color: #71747c;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  padding-bottom: 100px;
}
.news{
    margin: 0 260px;
    background:#fff;
  
  }
  .news-tabs{
    padding:33px 0 16px 0;
    display:flex;
    align-items:center;
    justify-content:center;
    width:100%;
  }
  .tab-item{
    position:relative;
    margin:0 186px 0 0;
    font-size:24px;
    font-weight:600;
    color:#111111;
    cursor:pointer;
  }
  .tab-item:last-child{
    margin:0 ;
  }
  .active{
    color:#476EE7;
  }
  .active:after{
    content: '';
    position:absolute;
    left:0;
    bottom:-16px;
    width: 96px;
    height: 4px;
    border-radius: 7px;
    background: linear-gradient(90deg, #06C4FE 0%, #6248DD 120.82%, rgba(255, 65, 55, 0) 120.83%, #6248DD 120.83%);
  }
  .news-content{
    padding:45px 74px 14px 74px;
    display:flex;
  }
  .content-left{
    padding-right:43px;
    border-right: 1px solid #EAEFF5;
  }
  .content-right{
    padding-left:51px;
  }
  .news-item{
    display:flex;
    align-items:center;
    justify-content:space-between;
    font-size:18px;
    color:#111111;
    /* font-weight:600; */
    margin-bottom:40px;
    cursor:pointer;
  }
  .news-item:hover{
    color:#476EE7;
  }
  .news-left{
    width: 396px;
    margin:0 44px 0 0;
    text-align:left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .news-right{
    font-size:14px;
    font-weight:400;
  }
  .more-icon{
    width:14px;
    height:14px;
    margin-left:5px;
  }
  .more-box{
    font-size:14px;
    color:#71747C;
    cursor:pointer;
  }
  .more-box:hover{
    color:#476EE7;
  }
  .more-box:hover .more-icon{
    content:url('../../assets/more-icon.png')
  }
  .title-top{
    display:flex;
    align-items:center;
    justify-content:space-between;
    font-size:24px;
    font-weight:600;
    color:#111111;
    margin:0 0 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue